module.exports = __webpack_public_path__ + "img/bg-smooth.75ba7ce5.jpg";